import * as _4 from 'lodash4';
import { ConversationFilterStrategy } from '../../strategies/conversation_filter_strategy';

export class ConversationListController {
  private activeFilter: string;
  private title: string;
  private showNotificationSettingsLink: boolean;

  constructor(private $stateParams: ng.ui.IStateParamsService, private appConfigModel: any) {
    this.activeFilter = this.$stateParams.filter;
    this.title = `${ConversationFilterStrategy.getByKey(this.activeFilter).name} Notifications`;
    this.showNotificationSettingsLink = this.appConfigModel.isFeatureEnabled('notification-settings');
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-conversations/src/views/conversation_list/conversation_list_controller.ts